import { Body1, H3, TextAndImage } from '@cointracker/styleguide';
import { Grid } from '@cointracker/styleguide/src/Grid';
import { LandingFeatureButton } from '../LandingFeature';
import {
  feature,
  featureSubtitle,
  featureTitle,
  styledUnorderedList,
} from './Feature.css';

export interface FeatureProps {
  buttonText?: string;
  title: string;
  subtitle?: string;
  subtitleList?: string[];
  handleTracking?: () => void;
  imgSrc: string;
  imgAlt: string;
}

export const Feature = (props: FeatureProps) => {
  const {
    buttonText,
    title,
    subtitle,
    subtitleList,
    imgSrc,
    imgAlt,
    handleTracking,
  } = props;

  return (
    <Grid>
      <TextAndImage className={feature} imgSrc={imgSrc} imgAlt={imgAlt}>
        <div className={featureTitle}>
          <H3>{title}</H3>
        </div>
        {subtitle && (
          <div className={featureSubtitle}>
            <Body1 variant="secondary">{subtitle}</Body1>
          </div>
        )}
        {subtitleList && (
          <ul className={styledUnorderedList}>
            {subtitleList.map((f, index) => (
              <li key={index}>
                <Body1 variant="secondary">{f}</Body1>
              </li>
            ))}
          </ul>
        )}
        {handleTracking && (
          <LandingFeatureButton onClick={handleTracking}>
            {buttonText ?? 'Get CoinTracker'}
          </LandingFeatureButton>
        )}
      </TextAndImage>
    </Grid>
  );
};
